import {IServices, IServicesListItem, ServicesResponseType} from "@/entity/services/services.types";

export default class Services implements IServices {
    total: number;
    data: IServicesListItem[] = [];
    constructor(data: ServicesResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}